<div class="main-content">
	<div class="container-fluid">
		<div class="row">
			<div class="col-md-12">
				<div class="card">
					<div class="card-header card-header-{{color}}-5">
						<h4 class="card-title"><i class="material-icons" (click)="back()">arrow_left</i> Inventory Upload</h4>
					</div>
					<div class="card-body">
						<ng-container>
							<div class="row">
								<div class="col-md-3 mb-3">
									<!-- <mat-slide-toggle class="nav-link" [formControl]="preflight">
										<mat-label>Pre Flight Only</mat-label>
									</mat-slide-toggle> -->

									<ngx-dropzone [multiple]="false" (change)="onSelect($event)">
										<ngx-dropzone-label class="m-2">
											DROP FILE HERE OR CLICK TO UPLOAD
										</ngx-dropzone-label>
										<ngx-dropzone-preview *ngFor="let f of uploadFiles" [removable]="true" (removed)="onRemove(f)" (error)="onUploadError($event)" (success)="onUploadSuccess($event)">
											<ngx-dropzone-label>{{ f.name }} ({{ f.type }})</ngx-dropzone-label>
										</ngx-dropzone-preview>
									</ngx-dropzone>
								</div>
								<div class="col-md-9">
									<mat-spinner matPrefix diameter="30" *ngIf="sending"></mat-spinner>
									Choose Import Types:
									<form [formGroup]="optionForm">
									<mat-slide-toggle (change)="adjustMapping()" formControlName="stockmaster"> Item Import </mat-slide-toggle>
									<mat-slide-toggle (change)="adjustMapping()" formControlName="prices"> Item Prices </mat-slide-toggle>
									<mat-slide-toggle (change)="adjustMapping()" formControlName="purchdata"> Purchase Data </mat-slide-toggle>
									<mat-slide-toggle (change)="adjustMapping()" formControlName="pricematrix"> Quantity Breaks </mat-slide-toggle>
									<mat-slide-toggle (change)="adjustMapping()" formControlName="tireinfo" *ngIf="config.env.package == 'tires'"> Tire Info </mat-slide-toggle>
									</form>
								</div>
							</div>
						</ng-container>
						<ng-container *ngIf="mapcols?.length > 1 && UploadedHeaders?.length && !preview">
							<h4>{{ uploaddata?.length }} records to import</h4>
							<form [formGroup]="mappingForm">
							<div class="row">
							<div class="col-md-4" *ngFor="let m of mapcols;">
							<mat-form-field>
							<mat-label>{{m.label}}</mat-label>
							<mat-select formControlName="{{m.field}}">
							<mat-option *ngFor="let h of UploadedHeaders" value="{{h}}">
							{{h}}
							</mat-option>
							</mat-select>
							</mat-form-field>
							</div>
							</div>
							</form>
							<div class="text-right">
								<button class="btn btn-primary" (click)="process(uploaddata)">Pre-Process</button>
							</div>
						</ng-container>
						<ng-container *ngIf="mappeddata.length && preview">
						<table class="table table-striped">
						<tr><th [attr.colspan]="colspan"> File Mapping Preview </th><th><button class="btn btn-primary" (click)="submit()">Submit Changes</button></th><th></th></tr>
						<tr><th></th><th *ngFor="let m of mapped">{{m.label}}</th></tr>
						<ng-container *ngFor="let m of mappeddata">
						<tr [ngClass]="{'hasProblem': m.problem != ''}"><td><div style="vertical-align:center;height:100%;float:left"><button class="btn btn-sm btn-success" (click)="investigate(m)"><mat-icon>search</mat-icon></button></div><div *ngIf="m.problem != ''" style="font-size:0.8em;color:red;font-weight:bold;text-align:center;float:left;width:flex;margin-left:20px;" [innerHtml]="m.problem"></div></td><td *ngFor="let m2 of mapped">{{m[m2.field]}}</td><td style="font-size:0.8em;color:red;font-weight:bold;text-align:center" [innerHtml]="m.problem"></td></tr>
						</ng-container>
						</table>
						</ng-container>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
